
export class AppVersion {

  number!: string;
  commit!: string;
  buildTime!: Date;

  static current: AppVersion = { number: '57', commit: '71e8bf1', buildTime: new Date('2026-06-01T07:49:27.888Z') };
}